import { createReducer, Action, on } from '@ngrx/store';
import {
  addRainBookingRemarksComplete,
  initializeGuestForm,
  initializeInitialBookingState,
  resetAddRainBookingRemarksStatus,
  setBookingDirectionality,
  setInitialBookingCurrentFlightSearchId,
  setInitialBookingGuestBioForm,
  setInitialBookingGuestMileagePlanForm,
  setInitialBookingGuestAutoFillData,
  setInitialBookingReservationInformationForm,
  setRainBookingRemarksAdded,
  updateFareRulesCheckboxState,
} from './initial-booking.actions';
import { guestFormsAdapter, initialInitialBookingEntityState } from './initial-booking.state';
import { AddDeleteRemarkStatus } from '../../../dtos/response/remarks-response/add-delete-remark-status';

const featureReducer = createReducer(
  initialInitialBookingEntityState,
  on(initializeInitialBookingState, (state) => ({ ...state, ...initialInitialBookingEntityState })),
  on(addRainBookingRemarksComplete, (state, { status }) => {
    return {
      ...state,
      addRainBookingRemarksStatus: status,
    };
  }),

  on(resetAddRainBookingRemarksStatus, (state) => {
    return {
      ...state,
      addRainBookingRemarksStatus: AddDeleteRemarkStatus.NONE,
    };
  }),

  on(setRainBookingRemarksAdded, (state) => {
    return {
      ...state,
      rainBookingRemarksAdded: true,
    };
  }),

  on(updateFareRulesCheckboxState, (state, { checked }) => {
    return {
      ...state,
      fareRulesAgreed: checked,
    };
  }),
  on(setInitialBookingCurrentFlightSearchId, (state, { flightSearchId }) => {
    return {
      ...state,
      currentFlightSearchId: flightSearchId,
    };
  }),
  on(setInitialBookingReservationInformationForm, (state, { reservationInformationForm }) => {
    return {
      ...state,
      reservationInformationForm,
    };
  }),
  on(initializeGuestForm, (state, { id }) => {
    return {
      ...state,
      guestForms: guestFormsAdapter.setOne(
        {
          id,
          bioForm: {
            firstName: '',
            firstNameValid: false,
            middleName: '',
            middleNameValid: false,
            lastName: '',
            lastNameValid: false,
          },
        },
        state.guestForms
      ),
    };
  }),
  on(setInitialBookingGuestBioForm, (state, { id, guestBioForm }) => {
    return {
      ...state,
      guestForms: guestFormsAdapter.updateOne(
        {
          id,
          changes: {
            bioForm: guestBioForm,
          },
        },
        state.guestForms
      ),
    };
  }),
  on(setInitialBookingGuestMileagePlanForm, (state, { id, mileagePlanAirline, mileagePlanNumber }) => {
    return {
      ...state,
      guestForms: guestFormsAdapter.updateOne(
        {
          id,
          changes: {
            mileagePlanAirline,
            mileagePlanNumber,
          },
        },
        state.guestForms
      ),
    };
  }),
  on(setInitialBookingGuestAutoFillData, (state, { id, autoFillData }) => {
    return {
      ...state,
      guestForms: guestFormsAdapter.updateOne(
        {
          id,
          changes: {
            autoFillData,
          },
        },
        state.guestForms
      ),
    };
  }),
  on(setBookingDirectionality, (state, { directionality }) => {
    return {
      ...state,
      directionality,
    };
  })
);

export function initialBookingReducer(state = initialInitialBookingEntityState, action: Action) {
  return featureReducer(state, action);
}
